module.exports = __webpack_public_path__ + "img/no-team.bb413cc8.png";